import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的工单ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入工单名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
}

export let batchRules = {
  file: [
    {...makeRule('请上传文件', 'object')},
  ],
  starttime: [
    {...makeRule('请选择时间')},
  ],
  orderid: [
    {...makeRule('请输入工单id', 'integer')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/order/order.rules.js